import { cn } from '@pmai/ui';

/**
 * A technology's 60×60 logo (FR-TECH-001) — or 🧩 on the catalogue card when there is none.
 * `small` is the chip size (FR-TECH-007), where a missing logo shows nothing.
 */
export function TechLogo({ logo, small = false }: { logo: string | null; small?: boolean }) {
  if (logo)
    return (
      <img src={logo} alt="" className={cn('rounded object-contain', small ? 'size-5' : 'size-[60px]')} />
    );
  if (small) return null;
  return (
    <span aria-hidden className="flex size-[60px] items-center justify-center rounded bg-canvas text-3xl">
      🧩
    </span>
  );
}
